import { decrementQuantity, deleteFromCart, incrementQuantity } from "../../redux/cartSlice";
import toast from "react-hot-toast";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { DLT, ADD, REMOVE } from '../../redux/Actions/action';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Timestamp, addDoc, collection } from "firebase/firestore";
import { fireDB } from "../../firebase/FirebaseConfig";
import BuyNowModal from "../../components/BuynowModal/BuyNowModal";
import { Navigate } from "react-router";
import emailjs from 'emailjs-com'; 
import CashOnDeliveryModal from "./CashOnDelivery";

const CartPage = () => {

    const navigate = useNavigate();
    const cartItems = useSelector((state) => state.cartreducer.carts);
    const dispatch = useDispatch();
    const { id } = useParams();

    // State for warranty selection
    const [warranty, setWarranty] = useState(0);
    const [productSize, setProductsize] = useState("");
    const deleteCart = (id) => {
        dispatch(DLT(id));
        toast.success("Item removed from cart");
    };

    const send = (e) => {
        dispatch(ADD(e));
    };

    const remove = (item) => {
        dispatch(REMOVE(item));
    };

    const cartItemTotal = cartItems
        .map(item => item.quantity)
        .reduce((prevValue, currValue) => prevValue + currValue, 0);

    const cartTotal = cartItems
        .map(item => item.price * item.quantity)
        .reduce((prevValue, currValue) => prevValue + currValue, 0);

    // Calculate total with warranty
    const finalTotal = cartTotal + warranty;

    useEffect(() => {
        localStorage.setItem('cart', JSON.stringify(cartItems));
    }, [cartItems, warranty]);

    // User info from local storage
    const user = JSON.parse(localStorage.getItem('users'));

    // State for address info
    const [addressInfo, setAddressInfo] = useState({
        name: "",
        city: "",
        address: "",
        pincode: "",
        mobileNumber: "",
        time: Timestamp.now(),
        date: new Date().toLocaleString("en-US", {
            month: "short",
            day: "2-digit",
            year: "numeric",
        })
    });

    // Handle warranty selection
    const handleWarrantyChange = (e) => {
        const selectedWarranty = parseInt(e.target.value);
        setWarranty(selectedWarranty);
    };
    const handleProductSizeChange = (e) => {
        const selectedSize = e.target.value;
        setProductsize(selectedSize);
    };

    // Buy Now Function
    const buyNowFunction = async () => {
        if (addressInfo.name === "" || addressInfo.city === "" || addressInfo.address === "" || addressInfo.pincode === "" || addressInfo.mobileNumber === "") {
            return toast.error("All fields are required");
        } else if (addressInfo.name.length < 3 || addressInfo.address.length < 4 || addressInfo.pincode.length < 6 || addressInfo.mobileNumber.length < 10) {
            return toast.error("Enter valid data");
        }

     


        var options = {
            key: "rzp_test_X7QQIYeQs9U2P2",
            key_secret: "Ol4Zxjufs54CQOnZfGUe5m",
    
            amount: parseInt(finalTotal * 100),
            currency: "INR",
            order_receipt: 'order_rcptid_' + addressInfo.name,
            name: "Durapot",
            description: "for testing purpose",
              // Email goes here 👇
          prefill: {
          email: user.email,
          name: addressInfo.name,
   
  },
            handler: function (response) {
              // console.log(response)
              toast.success('Payment Successful')
              const paymentId = response.razorpay_payment_id
              // store in firebase 
              const orderInfo = {
                cartItems,
                addressInfo,
                email: user.email,
                userid: user.uid,
                status: "confirmed",
                totalAmount: finalTotal,
                productSize: productSize,
                paymentId,
                time: Timestamp.now(),
            
            };
            
            
              try {
                const result = addDoc(collection(fireDB, "order"), orderInfo)
                console.log(result);
                
                
               const cartDetails = cartItems.map((item, index) => {
                return `
                   <div style="margin-bottom: 20px;">
      <p><strong>${index + 1}.</strong></p>
      <p><strong>Order ID:</strong> ${item.id}</p>
      <p><strong>Title:</strong> ${item.title}</p>
      <p><strong>Quantity:</strong> ${item.quantity}</p>
      <p><strong>Price:</strong> ₹${item.price}</p>
      <p><strong>Product Image:</strong></p>
      <img src="${item.productImageUrl}" alt="Product Image" width="150" style="border-radius: 8px;"/>
    </div>
                   
                `;
              }).join("\n");
              
    // 2. Send email using EmailJS
    const templateParams = {
        email: user.email,
        user_name: addressInfo.name,
        payment_id: paymentId,
        amount: finalTotal,
        cartDetails: cartDetails,
        status: "Confirmed"
      };
  
      emailjs.send(
        'service_a338tdf',
        'template_m3c8cu7',
        templateParams,
        '6JEbrtNYaUZl84V6I'
      ).then(
        (result) => {
          console.log('Email sent!', result.text);
        },
        (error) => {
          console.log('Email sending failed:', error);
        }
      );
  
             
                  // Redirect to the home page after successful payment and order creation
                 navigate('/');
                
              } catch (error) {
                console.log(error)
              }
            },
      
            theme: {
              color: "#3399cc"
            }
      
      
          };
          var pay = new window.Razorpay(options);
          pay.open();
          console.log(pay)



    };






      // Cash on DeliveryFunction
      const cashOnDeliveryFunction = async () => {
        if (addressInfo.name === "" || addressInfo.city === "" || addressInfo.address === "" || addressInfo.pincode === "" || addressInfo.mobileNumber === "") {
            return toast.error("All fields are required");
        } else if (addressInfo.name.length < 3 || addressInfo.address.length < 4 || addressInfo.pincode.length < 6 || addressInfo.mobileNumber.length < 10) {
            return toast.error("Enter valid data");
        }

        const orderInfo = {
            cartItems,
            addressInfo,
            email: user.email,
            userid: user.uid,
            status: "confirmed",
            // productSize: productSize,
            totalAmount: finalTotal,
            time: Timestamp.now(),
         
        };

        try {
            const orderRef = collection(fireDB, 'order');
            await addDoc(orderRef, orderInfo);
            setAddressInfo({
                name: "",
                city: "",
                address: "",
                pincode: "",
                mobileNumber: "",
            });
               dispatch({ type: "EMPTY_CART" }); // Use an action to reset the cart state

               const cartDetails = cartItems.map((item, index) => {
                return `
                   <div style="margin-bottom: 20px;">
      <p><strong>${index + 1}.</strong></p>
      <p><strong>Order ID:</strong> ${item.id}</p>
      <p><strong>Title:</strong> ${item.title}</p>
      <p><strong>Quantity:</strong> ${item.quantity}</p>
      <p><strong>Price:</strong> ₹${item.price}</p>
      <p><strong>Color:</strong> ${item.selectedColor}</p>
      <p><strong>Size:</strong> ${item.selectedSize}</p>
      <p><strong>Product Image:</strong></p>
      <img src="${item.productImageUrl}" alt="Product Image" width="150" style="border-radius: 8px;"/>
    </div>
                   
                `;
              }).join("\n");
              
      // 2. Send email using EmailJS
      const templateParams = {
        email: user.email,
        user_name: addressInfo.name,
        amount: finalTotal,
        status: "Confirmed",
        cartDetails: cartDetails
      };
      
  
      emailjs.send(
        'service_a338tdf',
        'template_ly28kxg',
        templateParams,
        '6JEbrtNYaUZl84V6I'
      ).then(
        (result) => {
          console.log('Email sent!', result.text);
        },
        (error) => {
          console.log('Email sending failed:', error);
        }
      );
  
         toast.success("Order placed successfully");
           
            navigate("/");
           

        } catch (error) {
            console.log(error);
        }

    }

  
    return (
        <div className="container mx-auto px-4 max-w-7xl lg:px-0">
            <div className="mx-auto max-w-2xl py-8 lg:max-w-7xl">
                <h1 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
                    Shopping Cart
                </h1>
                <form className="mt-12 lg:grid lg:grid-cols-12 lg:items-start lg:gap-x-12 xl:gap-x-16">
                    <section aria-labelledby="cart-heading" className="rounded-lg bg-white lg:col-span-8">
                        <ul role="list" className="divide-y divide-gray-200">
                            {cartItems.length > 0 ? (
                                <>
                                    {cartItems.map((item, index) => {
                                        const { id, title, price, productImageUrl, quantity, category,sizeCode,selectedColor } = item;
                                        return (
                                            <div key={index}>
                                                <li className="flex py-6">
                                                    <div className="flex-shrink-0">
                                                    <a href={productImageUrl} target="blank">
                                                        <img
                                                            src={productImageUrl}
                                                            alt="img"
                                                            className="sm:h-48 sm:w-48 h-32 w-28 rounded-md object-contain object-center"
                                                        /></a>
                                                    </div>
                                                    <div className="ml-4 flex flex-1 flex-col justify-between">
                                                        <div>
                                                            <h3 className="md:text-lg text-sm font-outfit font-semibold text-black">{title}</h3>
                                                            <p className="md:text-lg text-sm font-outfit text-gray-500">{category}</p>
                                                            <p className="md:text-lg text-sm font-outfit font-medium text-gray-900">
                                                                ₹{price}
                                                            </p>
                                                            <p className="md:text-lg text-sm font-outfit font-medium text-blue-700">
                                                           Size: {sizeCode}
                                                            </p>
                                                            <div className="flex items-center space-x-2">
                                                            <p className="md:text-lg text-sm font-outfit font-medium ">
    {selectedColor}
  </p>
  <span
    className="inline-block w-4 h-4 rounded-full border border-gray-400"
    style={{
      backgroundColor:
        selectedColor === "Grey Stone"
          ? "#7d7d7d"
          : selectedColor === "Marble White"
          ? "#f0f0f0"
          : selectedColor === "Sandstone"
          ? "#d2b48c"
          : selectedColor === "Mosaic Grey"
          ? "#a9a9a9"
          : "transparent",
    }}
  ></span>

</div>

                                                            
                                                          
                                                        </div>
                                                    </div>
                                                </li>
                                                <div className="flex">
                                                    <button type="button" onClick={() => remove(item)} className="h-7 w-7">-</button>
                                                    <input
                                                        type="text"
                                                        className="mx-1 h-7 w-9 border text-center"
                                                        value={quantity}
                                                        readOnly
                                                    />
                                                    <button type="button"  onClick={() => send(item)} className="h-7 w-7">+</button>
                                                    <button type="button" onClick={() => deleteCart(item.id)} className="text-red-500 ml-4">Remove</button>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </>
                            ) : (
                                <h1>Cart is empty</h1>
                            )}
                        </ul>
                    </section>

                    {/* Order Summary */}
                    <section className="mt-16 rounded-md bg-white lg:col-span-4">
                        <dl className="space-y-1 px-2 py-4">
                            <div className="flex justify-between font-semibold text-lg font-outfit">
                                <dt className="font-medium">Price ({cartItemTotal} items)</dt>
                                <dd>₹{cartTotal}</dd>
                            </div>
                            <div className="flex justify-between font-semibold text-lg font-outfit">
                                <dt className="font-medium">Delivery Charges</dt>
                                <dd >Free</dd>
                            </div>

                            {/* Warranty Section */}
                            {/* <div className="flex justify-between text-lg font-outfit">
                                <dt className="font-medium">pot Size</dt>
                                <select
                                    value={productSize}
                                    onChange={handleProductSizeChange}
                                    className="border rounded p-1"
                                >
                                    <option >Choose pot size</option>
                                    <option value="14 inch">14 inch</option>
                                    <option value="16 inch">16 inch</option>
                                    <option value="18 inch">18 inch</option>
                                </select>
                            </div> */}

                            <div className="flex justify-between border-t py-4  text-lg font-outfit">
                                <dt className="font-medium">Total Amount</dt>
                                <dd className="font-semibold">₹{finalTotal}</dd>
                            </div>
                        </dl>
                        {user ? (
                            <div>

                          
                            <CashOnDeliveryModal 
                                addressInfo={addressInfo}
                                setAddressInfo={setAddressInfo}
                                cashOnDeliveryFunction={cashOnDeliveryFunction}
                            />
                            <br />
                            <BuyNowModal
                                addressInfo={addressInfo}
                                setAddressInfo={setAddressInfo}
                                buyNowFunction={buyNowFunction}
                            />
                              </div>
                        ) : (
                            <Navigate to="/login" />
                        )}
                    </section>
                </form>
            </div>
        </div>
    );
};

export default CartPage;